import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6b59b5e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_wrapper" }
const _hoisted_2 = { class: "header_inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header_logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header_text" }, "マイページ", -1))
const _hoisted_5 = { class: "header_lyaout_menu" }

import HeaderMenu from '@/components/HeaderMenu.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTypeD',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeaderMenu)
        ])
      ])
    ])
  ]))
}
}

})